module.exports = __webpack_public_path__ + "img/mullins-dragon.5543c00c.jpg";